import { createAvatarUrlFromName } from 'lib/utils'

const GroupInfo = ({
  name,
  identifier,
  usersCount = 0,
  imgClassName = 'mx-2 my-auto w-7 h-7 rounded-full',
}: {
  name: string
  identifier: string
  usersCount?: number
  imgClassName?: string
}) => {
  const imgUrl = createAvatarUrlFromName(name)

  return (
    <span className="flex flex-row gap-1 p-1">
      <img alt={name} className={imgClassName} src={imgUrl} />
      <div className="flex flex-col flex-grow my-auto text-gray-600 text-sm">
        <div className="font-medium">{`${name} (${usersCount})`}</div>
        <div className="text-xs">{identifier}</div>
      </div>
    </span>
  )
}

export default GroupInfo
